<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(observation.observation_id ? 'Edit Observation: ' + observation.observation_id : 'New Observation') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/observations`">
                            <i class="fa fa-comment-o"></i> Observations
                        </router-link>
                    </li>
                    <template v-if="observation.observation_id">
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                            <router-link :to="`/observations/view/${observation.observation_id}`">
                                {{ observation.observation_date  | moment("MM/DD/YYYY") }} - {{ observation.FirstName + ' ' + observation.LastName  }} - JOB#{{ observation.JobsiteNumber }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">Edit</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">New Observation</li>
                    </template>
                </ol>
            </h4>

            <button type="button" class="btn btn-success" @click="saveObservation(this)" :disabled="saving">
                <template v-if="saving">
                    Saving <i class="fa fa-spinner"></i>
                </template>
                <template v-else>
                    <span v-if="observation.observation_id">Update</span>
                    <span v-else>Save</span>
                    Observation
                </template>
            </button>
            <hr/>

            <div class="row">
                <div class="col-xl-9 col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">Edit Observation</div>
                        <div class="card-body">

                            <div v-if="this.$root.hasPermission('inspections.manage')" v-bind:class="{ 'form-group row': true, 'has-error': errors.UserId }">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">For User</label>
                                <div class="col-sm-8">
                                    <user-select :selectedValues="userSelectValues" @vuselected="onUserSelectUpdate" :filters="{is_active: 1}"></user-select>
                                    <span v-if="errors.UserId" class="text-danger">
                                        <span v-for="error in errors.UserId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.jobsite_id }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.jobsite_id}">Jobsite <i class="fa fa-asterisk text-danger"></i></label>
                                <div class="col-sm-8">
                                    <jobsite-select :selectedValues="jobsiteValue" @vselected="onJobSiteSelectUpdate" :hasError="errors.jobsite_id ? true : false" :filters="{'jobsite.IsActive': 1}"></jobsite-select>
                                    <span v-if="errors.jobsite_id" class="text-danger">
                                        <span v-for="error in errors.jobsite_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.observation_date }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Date</label>
                                <div class="col-sm-8">
                                    <!-- <date-picker v-model="observation.observation_date" @dp-change="datePickerChanged" :config="options" ></date-picker> -->
                                    <input type="date" v-model="observation.observation_date" :class="{'form-control': true, 'is-invalid': errors['action.observation_date']}" placeholder="Enter Date of Observation" />
                                    <span v-if="errors.observation_date" class="text-danger">
                                        <span v-for="error in errors.observation_date">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-xl-9 col-lg-10 col-md-12 mt-3">
                    <div class="card mb-3">
                        <div class="card-header">Inspection Item</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Form:</label>
                                <div class="col-sm-8">
                                    <b-input-group class="mb-1">
                                        <b-form-select v-model="observation.inspection_form_id" :options="formOptions" v-on:change="loadFormSections"></b-form-select>
                                        <b-input-group-append v-if="formLoading">
                                            <span class="ml-2 mt-1"><i class="fa fa-circle-o-notch fa-spin"></i></span>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <span v-if="errors.inspection_form_id" class="text-danger">
                                        <span v-for="error in errors.inspection_form_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Section:</label>
                                <div class="col-sm-8">
                                    <b-input-group class="mb-1">
                                        <b-form-select v-model="observation.InspectionSectionId" :options="sectionOptions" :disabled="formLoading"></b-form-select>
                                        <b-input-group-append v-if="observation.InspectionSectionId != null">
                                            <b-button v-on:click="observation.InspectionSectionId = null" variant="light" title="Clear Section"><i class="fa fa-remove"></i> Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <span v-if="errors.InspectionSectionId" class="text-danger">
                                        <span v-for="error in errors.InspectionSectionId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.inspection_element_id}">Element:</label>
                                <div class="col-sm-8">
                                    <select v-model="observation.inspection_element_id" @change="setSectionByElement" :disabled="formLoading" :class="{'form-control': true, 'is-invalid': errors.inspection_element_id}">
                                        <option :value="null">-- Selection an Element</option>
                                        <optgroup v-for="section in sections" :label="`${section.DisplayOrder}. ${section.SectionName}`"
                                                    v-if="!observation.InspectionSectionId || observation.InspectionSectionId == null || observation.InspectionSectionId == section.InspectionSectionId">
                                            <option v-for="element in section.elements" :value="element.InspectionElementId">
                                                {{ section.DisplayOrder }}.{{ element.DisplayOrder }} {{ element.ElementText }}
                                            </option>
                                        </optgroup>
                                    </select>

                                    <span v-if="errors.inspection_element_id" class="text-danger">
                                        <span v-for="error in errors.inspection_element_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-9 col-lg-10 col-md-12 mt-3">
                    <div class="card mb-3">
                        <div class="card-header" :class="{'text-danger': errors.compliance_status_id}">Compliant or Non-Compliant <i class="fa fa-asterisk text-danger"></i></div>
                        <div class="card-body">
                            <b-form-radio-group :class="{'is-invalid': errors.compliance_status_id}" plain v-model="observation.compliance_status_id" :disabled="(observation.observation_id ? true : false)">
                                <b-form-radio :value="1">Compliant</b-form-radio>
                                <b-form-radio :value="2">Non-Compliant</b-form-radio>
                            </b-form-radio-group>

                            <div v-if="errors.compliance_status_id" class="text-danger">
                                <span v-for="error in errors.compliance_status_id">{{ error }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-9 col-lg-10 col-md-12 mt-3">

                    <div class="card mb-3" v-if="observation.compliance_status_id === 1">
                        <div class="card-header">Compliant Comments & Files/Photos</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.subcontractor_id}">
                                    Subcontractor (Optional):
                                </label>
                                <div class="col-sm-8">

                                    <subcontractor-select :selectedValues="ObsvSubValues" @vselected="onObsvSubSelectUpdate" :hasError="errors.subcontractor_id ? true : false"></subcontractor-select>

                                    <span v-if="errors['action.subcontractor_id']" class="text-danger">
                                        <span v-for="error in errors['action.subcontractor_id']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{'has-error': errors.comments }" class="row form-group">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Comment:
                                </label>
                                <div class="col-sm-8">
                                    <textarea :class="{ 'is-invalid': errors.comments, 'form-control': true}" v-model="observation.comments" placeholder="Enter Observation Comment" style="min-height: 100px;"></textarea>
                                    <span v-if="errors.comments" class="text-danger">
                                        <span v-for="error in errors.comments">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{'has-error': errors.comments }" class="row form-group">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Files/Photos:
                                </label>
                                <div class="col-sm-8">
                                    <b-form-file v-model="newFiles" multiple placeholder="Add Files, Photos, or Other Documents"></b-form-file>

                                    <span v-if="errors.files" class="text-danger">
                                        <span v-for="error in errors.files">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3" v-else-if="observation.compliance_status_id === 2">
                        <div class="card-header">Corrective Action</div>
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors['action.detail'] }" class="row" v-if="!observation.observation_id">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Closed Action
                                </label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="is_closed" :value="true" :unchecked-value="false" plain :disabled="!observation.inspection_element_id">Check to create a Closed Corrective Action</b-form-checkbox>
                                    <span class="small text-info" v-if="!observation.inspection_element_id">-- Select the Inspection Item Element Above to Enable Closed Action --</span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors['action.detail'] }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Explain Observation: <i class="fa fa-asterisk text-danger small"></i>
                                </label>
                                <div class="col-sm-8">
                                    <textarea :class="{ 'is-invalid': errors['action.detail'], 'form-control': true}" v-model="observation.action.detail" placeholder="Enter Details" style="min-height: 100px;"></textarea>
                                    <span v-if="errors['action.detail']" class="text-danger">
                                        <span v-for="error in errors['action.detail']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors['action.completed_detail'] }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Corrective Action Completed Detail:  <i class="fa fa-asterisk text-danger small" v-if="completedDetailRequired"></i>
                                </label>
                                <div class="col-sm-8">
                                    <textarea :class="{ 'is-invalid': errors['action.completed_detail'], 'form-control': true}" v-model="observation.action.completed_detail" placeholder="Enter Completed Details" style="min-height: 100px;"></textarea>
                                    <span v-if="errors['action.completed_detail']" class="text-danger">
                                        <span v-for="error in errors['action.completed_detail']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors['action.status_id'] }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Status: <i class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">
                                    <select :class="{ 'is-invalid': errors['action.status_id'], 'form-control': true}" v-model="observation.action.status_id">
                                        <option :value="null">-- Select a Status --</option>
                                        <option v-for="(value, key) in statuses" v-bind:value="value.status_id">
                                            {{ value.status_name }}
                                        </option>
                                    </select>
                                    <span v-if="errors['action.status_id']" class="text-danger">
                                        <span v-for="error in errors['action.status_id']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors['action.corrective_source_id'] }" class="row" v-if="Object.keys(sources).length > 0">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Source:</label>
                                <div class="col-sm-8">
                                    <select :class="{ 'is-invalid': errors['action.corrective_source_id'], 'form-control': true}" v-model="observation.action.corrective_source_id">
                                        <option :value="null">-- Select a Source --</option>
                                        <option v-for="(value, key) in sources" v-bind:value="key">
                                            {{ value }}
                                        </option>
                                    </select>
                                    <span v-if="errors['action.corrective_source_id']" class="text-danger">
                                        <span v-for="error in errors['action.corrective_source_id']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <action-assignees ref="otherAssignees" v-model="observation.action" :errors="errors"></action-assignees>

                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Location: <i class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">
                                    <input type="text" name="location" v-model="observation.action.location" :class="{ 'is-invalid': errors['action.location'], 'form-control': true}" placeholder="Corrective Action Location" />
                                    <span v-if="errors['action.location']" class="text-danger">
                                        <span v-for="error in errors['action.location']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors['action.due_date'] }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Due Date:</label>
                                <div class="col-sm-8">
                                    <!-- <date-picker v-model="observation.action.due_date" :config="{format: 'YYYY-MM-DD', useCurrent: false}" :class="{ 'is-invalid': errors['action.due_date'] }" placeholder="Enter Date to be Completed By"></date-picker> -->
                                    <input type="date" v-model="observation.action.due_date" :class="{'form-control': true, 'is-invalid': errors['action.due_date']}" placeholder="Enter Date to Be Completed By" />
                                    <span v-if="errors['action.due_date']" class="text-danger">
                                        <span v-for="error in errors['action.due_date']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Is Subcontractor:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="observation.action.is_subcontractor" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>

                            <div v-if="observation.action.is_subcontractor == 1">
                                <div class="form-group row">
                                    <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors['action.subcontractor']}">Subcontractor Name:</label>
                                    <div class="col-sm-8">

                                        <b-form-input type="text" :class="{ 'is-invalid': errors['action.subcontractor']}" v-model="observation.action.subcontractor" placeholder="Enter Subcontractor" />

                                        <div class="text-info small">This is a free text field to enter the Subcontractor name. Any value is accepted.</div>

                                        <span v-if="errors['action.subcontractor']" class="text-danger">
                                            <span v-for="error in errors['action.subcontractor']">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors['action.subcontractor_id']}">Subcontractor Record:</label>
                                    <div class="col-sm-8">

                                        <subcontractor-select :selectedValues="SubcontractorValues" @vselected="onSubSelectUpdate" :hasError="errors['action.subcontractor_id'] ? true : false"></subcontractor-select>

                                        <div class="text-info small">This field links to your list of subcontractors in MeritEHS. Use this to associate and view corrective actions on the Subcontractor record.</div>

                                        <span v-if="errors['action.subcontractor_id']" class="text-danger">
                                            <span v-for="error in errors['action.subcontractor_id']">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>


                            <hr />

                            <div class="row my-2">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Add Files:</label>
                                <div class="col-sm-8">
                                    <b-form-file v-model="newFiles" plain multiple></b-form-file>
                                </div>
                            </div>
                            <hr />

                            <file-list :files="observation.action.files ? observation.action.files : []" />
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveObservation(this)" :disabled="saving">
                <template v-if="saving">
                    Saving <i class="fa fa-spinner"></i>
                </template>
                <template v-else>
                    <span v-if="observation.observation_id">Update</span>
                    <span v-else>Save</span>
                    Observation
                </template>
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                saving: false,
                formLoading: false,
                is_closed: false,
                observation_id: this.$route.params.id,
                observation: {},
                files: [],
                statuses: [],
                sources: [],
                sections: {},
                errors: {},
                options: {
                    format: 'MM/DD/YYYY',
                    date: ""
                },
                datePicked: new Date(),
                userSelectValues: {},
                newFiles: [],
            }
        },

        watch: {
            is_closed(newVal, oldVal){
                //Check for newVal
                if(newVal !== true)
                {
                    return;
                }

                //Set the Explanation
                for (var i = this.elementOptions.length - 1; i >= 0; i--)
                {
                    //Check Each Element
                    if(this.elementOptions[i].value == this.observation.inspection_element_id)
                    {
                        this.observation.action.detail = 'Non-Compliant: ' + this.elementOptions[i].text;
                    }
                }

                //Set the Due Date
                this.observation.action.due_date = moment().format('YYYY-MM-DD');

                //Set the Status
                var statusKeys = Object.keys(this.statuses);

                //Loop and Build
                for (var i = statusKeys.length - 1; i >= 0; i--)
                {
                    if(this.statuses[statusKeys[i]].status_context == 'Closed')
                    {
                        this.observation.action.status_id = this.statuses[statusKeys[i]].status_id;
                    }
                }

                //Set the Location
                this.observation.action.location = 'See Jobsite';

                //Set the Assignee to the Current User
                this.$refs.otherAssignees.assignToMe();

                //Force Update?
                //this.$forceUpdate();
            },
        },

        computed: {
            formOptions(){
                //Build the options
                var options = [];

                for(var i in this.forms)
                {
                    options.push({value: this.forms[i].inspection_form_id, text: this.forms[i].form_name})
                }

                //Send it
                return options;
            },

            sectionOptions(){
                var options = [
                    {value: null, text: '-- Select a Section --'}
                ];

                for(var i in this.sections)
                {
                    options.push({value: this.sections[i].InspectionSectionId, text: (this.sections[i].DisplayOrder + '. ' + this.sections[i].SectionName)})
                }

                return options;
            },

            elementOptions(){
                //Setup
                var options = [];

                //If a Section isn't selected, return diabled option
                if(!this.observation.InspectionSectionId || this.observation.InspectionSectionId == null)
                {
                    //Push the Placeholder
                    options.push({value: null, text: '-- Select a Section to Load Element Items --'});

                    //Stop here
                    return options;
                }

                //Loop and build
                options.push({value: null, text: '-- Select an Element Item --'});

                //Build from the options in the section
                for(var i in this.sections[this.observation.InspectionSectionId].elements)
                {
                    options.push({
                        value: this.sections[this.observation.InspectionSectionId].elements[i].InspectionElementId,
                        text: this.sections[this.observation.InspectionSectionId].DisplayOrder + '.' + this.sections[this.observation.InspectionSectionId].elements[i].DisplayOrder + ' ' +
                            this.sections[this.observation.InspectionSectionId].elements[i].ElementText,
                    });
                }

                //Send
                return options;
            },

            jobsiteValue(){
                //check for null
                if(!this.observation.jobsite_id || this.observation.jobsite_id == null)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite)
                    {
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the ID
                        this.observation.jobsite_id = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.observation.jobsite_id, JobsiteNumber: this.observation.JobsiteNumber, JobsiteName: this.observation.JobsiteName};
            },

            assigneeValue(){
                //Check for empty
                if(!this.observation.action.assignee_id || this.observation.action.assignee_id == null)
                {
                    return null;
                }

                //Send it
                return {UserId: this.observation.action.assignee_id, FirstName: this.observation.action.assignee_first_name, LastName: this.observation.action.assignee_last_name};
            },

            //Status Option Input
            statusOptions(){
                let options = {};

                //Loop
                for(var status in this.statuses)
                {
                    options[status.status_id] = status.status_name;
                }

                //Send it
                return options;
            },

            completedDetailRequired(){
                //Check the status
                if(!this.observation.action.status_id)
                {
                    return false;
                }

                //Check the status
                var status = this.statuses[this.observation.action.status_id];

                //Check it
                return status.status_context === 'Closed';
            },

            SubcontractorValues(){
                //check for null
                if(!this.observation.action || !this.observation.action.subcontractor_id || this.observation.action.subcontractor_id == null)
                {
                    //Send it
                    return null;
                }

                //Send it
                return {subcontractor_id: this.observation.action.subcontractor_id, subcontractor_name: this.observation.action.subcontractor_name};
            },

            ObsvSubValues(){
                //check for null
                if(!this.observation.subcontractor_id || this.observation.subcontractor_id == null)
                {
                    //Send it
                    return null;
                }

                //Send it
                return {subcontractor_id: this.observation.subcontractor_id, subcontractor_name: this.observation.subcontractor_name};
            },
        },

        methods: {
            //Get the Various Resources We Need to Edit a Jobsite
            getErrorClass(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getResources() {
                //Get the data
                this.$http
                    .get('corrective-actions/form-inputs')
                    .then(response => {
                        //Set the Data
                        this.statuses = response.data.statuses;
                        this.sources = response.data.actionSources;
                    });
            },

            getObservation() {
                //Get the data
                this.$http
                    .get('observations/edit' + (this.observation_id ? '/' + this.observation_id : ''))
                    .then(response => {
                        //Set all the data
                        this.observation = response.data.observation;

                        //Create a new action
                        if(!this.observation_id)
                        {
                            this.newAction();
                        }

                        //Set the Other Data
                        this.forms = response.data.forms;
                        this.sections = response.data.sections;
                        this.options.date = this.observation.observation_date;

                        //Set some user values
                        this.userSelectValues = {
                            UserId: this.observation.user_id,
                            FirstName: this.observation.FirstName,
                            LastName: this.observation.LastName
                        };

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveObservation() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithFiles('observations/edit' + (this.observation_id ? '/' + this.observation_id : ''), this.observation, this.newFiles)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Observation Saved');

                    //Return to main list?
                    this.$router.push('/observations/view/' + response.data.observation_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            onJobSiteSelectUpdate (jobsite) {
                //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.observation.JobsiteId = null;
                    return;
                }

                //Send the value
                this.observation.jobsite_id = jobsite.JobsiteId;
                //this.observation.JobsiteName = jobsite.JobsiteName;
                //this.observation.JobsiteNumber = jobsite.JobsiteNumber;
            },

            onUserSelectUpdate ( user ) {
                //Set the values
                this.observation.user_id = user.UserId;
                this.observation.FirstName = user.FirstName;
                this.observation.LastName = user.LastName;
            },

            assigneeSelected(user){
                //Set the values
                this.observation.action.assignee_id = user.UserId
                this.observation.action.FirstName = user.FirstName
                this.observation.action.LastName = user.LastName
            },

            datePickerChanged ( data ) {
                // Stringify datePicked
                var dateParts = data.target.value.split("/");
                this.observation.observation_date = dateParts[2]+'-'+dateParts[0]+'-'+dateParts[1];
            },

            loadFormSections(inspection_form_id){
                //Loading Indicator
                this.formLoading = true;

                //Send it
                this.$http.get('inspections/forms/sections/'+inspection_form_id+'?key_by=true')
                    .then(response => {
                        //Setter
                        this.sections = response.data;
                    })
                    .then(() => {
                        //Loading
                        this.formLoading = false;
                    });
            },

            setSectionByElement(event){
                //Setup
                var inspection_element_id = event.target.value;

                //Loop
                for(var i in this.sections)
                {
                    for(var t in  this.sections[i].elements)
                    {
                        if(this.sections[i].elements[t].InspectionElementId == inspection_element_id)
                        {
                            //For update
                            this.observation.InspectionSectionId = this.sections[i].InspectionSectionId;

                            //Stop here
                            return;
                        }
                    }
                }
            },

            newAction(){
                var newAction = {
                    status_id: null,
                    corrective_source_id: null,
                    assignee_id: null,
                    //due_date: (new Date()),
                };

                //Set it
                this.observation.action = newAction;
            },

            onSubSelectUpdate(sub) {
                //Check for null
                if(sub == null)
                {
                    //Clear the value
                    this.observation.action.subcontractor_id = '';

                    //Stop Here
                    return;
                }

                //Send the value
                this.observation.action.subcontractor_id = sub.subcontractor_id;
            },

            onObsvSubSelectUpdate(sub) {
                //Check for null
                if(sub == null)
                {
                    //Clear the value
                    this.observation.subcontractor_id = '';

                    //Stop Here
                    return;
                }

                //Send the value
                this.observation.subcontractor_id = sub.subcontractor_id;
            },
        },

        mounted() {
            //Get the Observation
            this.getResources();
            this.getObservation();
        }
    }
</script>
